<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">{{ this.$route.meta.title }}
        <div class="card-header-actions">
          <!-- <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button> -->
          <button class="btn btn-primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="3">
          <b-input-group>
            <b-input-group-prepend><span class="pt-2 mr-2">Trx Id</span></b-input-group-prepend>
            <b-form-input v-model="filter.trx_id"></b-form-input>
          </b-input-group>
        </b-col>

        <b-col md="5">
          <b-row>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()"> <i class="fa fa-refresh"></i> Apply
              Filter</b-button>
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear
              Filter</b-button>
          </b-row>
        </b-col>

      </b-row>

      <b-table class="mb-0" ref="table" outlined responsive hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" @row-clicked="rowClicked" :key="tblData.limit" show-empty>

        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>

        <template v-slot:cell(created_at)="data">
          <span>{{ data.item.created_at | moment('DD-MMM-YYYY HH:mm') }}</span>
        </template>

        <template v-slot:cell(parameter)="data">
          <pre>{{ JSON.parse(data.item.parameter) }}</pre>
        </template>

        <template v-slot:cell(response)="data">
          <pre style="width: 400px;">{{data.item.response}}</pre>
        </template>

        <template v-slot:cell(response_data_decrypt)="data">
          <pre>{{ JSON.parse(data.item.response_data_decrypt) }}</pre>
        </template>


      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span v-else>{{
        tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group>
            <b-input-group-prepend><span class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
            <b-form-select :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="tblData.limit"
              size="sm" style="max-width:80px;" />
          </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style lang="scss">
.input-group {
  padding-bottom: 2px;

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 100px;
    }
  }
}
</style>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import moment from "moment"
import { validationMixin } from "vuelidate";
toastr.init();



export default {
  components: {},
  mixins: [validationMixin],
  validations: {

  },
  data() {
    return {
      showDelConfirm: false,
      showList: true,
      showForm: false,
      lkuCustomerShow: false,
      bankOnly: 1,
      lkuBankaccountShow: false,
      tblData: {
        tablename: 'e-collection-log',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'created_at',
        sortDesc: false,
      },
      filter: { trx_id: '' }
    };
  },
  computed: {
    tblFields() {
      const fields = [


        {
          key: "trx_id",
          label: "Billing ID",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "client_id",
          label: "Client Id",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "virtual_account",
          label: "VA Number",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "parameter",
          label: "Parameter",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "response",
          label: "Response",
          thClass: "text-center",
          tdStyle: "width:100px !important",
          sortable: true
        },
        {
          key: "created_at",
          label: "Created At",
          thClass: "text-center",
          sortable: true
        }
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    disableInput() {
      return Object.keys(this.$route.params).length > 0
    },
  },
  watch: {
    'frmdata.billing_type'(val) {
      let obj = this.billingTypeOpt.find(x => x.value == val)
      this.frmdata.billing_type_desc = obj.description
    }
  },
  created: async function () {
    const [a] = await Promise.all([
      crud.list({
        tablename: 'project',
        page: 1,
        limit: 1000,
        total: 0,
        sortBy: null,
        sortDesc: true
      })
    ]);
    this.filtertypes = a.reduce((newArr = [{ value: '', text: '-- ALL --' }], item) => {
      newArr.push({ value: item.pjxkey, text: `${item.pjxcode} - ${item.pjxname}` });
      return newArr;
    }, [{ value: '', text: '-- ALL --' }]);

    if (this.$route.name == "loan.ecollectiontransactions") {
      const { model, showForm, showList } = this.$route.params
      if (model) {
        this.showForm = showForm
        this.showList = showList
        this.frmdata.nasabahkey = model.nasabahkey;
        this.frmdata.pinjamankey = model.pinjamankey;
        this.frmdata.pjxkey = model.pjxkey;
        this.frmdata.customer_name = model.CustName;
        this.frmdata.customer_email = model.email;
        this.frmdata.customer_phone = model.nohandphone;
        this.frmdata.virtual_account = model.vanumber
      }

    }
  },
  methods: {
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery = '';
      let str = '';

      
      if (this.filter.trx_id) {
        str = 'trx_id=' + encodeURIComponent(this.filter.trx_id);
      }
     

      this.tblData.customQuery = str;
      const list = await crud.list(this.tblData);
      list.map(dt => {
        let responseDt = {
          status: dt.response_status,
          data: JSON.parse(dt.response_data_decrypt)
        }

        dt.response = responseDt

      })
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.filter.pjxname = '';
      this.filter.pjxjobtype = '';
      this.refresh();
    },
  
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
    },
    close() {
      router.push("home");
    },
  }
};
</script>
